module.exports = __webpack_public_path__ + "img/2.27ef17b1.png";